// Маленькие DOM-хелперы с честными типами: всё, что может не найтись, возвращает null.

export function byId<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

/** Элемент, который обязан существовать (иначе это баг разметки) */
export function mustId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = byId<T>(id);
  if (!el) throw new Error(`Нет элемента #${id}`);
  return el;
}

export function q<T extends HTMLElement = HTMLElement>(root: ParentNode, sel: string): T | null {
  return root.querySelector<T>(sel);
}

export function qa<T extends HTMLElement = HTMLElement>(root: ParentNode, sel: string): T[] {
  return [...root.querySelectorAll<T>(sel)];
}

/** Ближайший HTMLElement-предок цели события по селектору */
export function closest<T extends HTMLElement = HTMLElement>(target: EventTarget | null, sel: string): T | null {
  if (!(target instanceof Element)) return null;
  return target.closest<T>(sel);
}

export function inputValue(id: string): string {
  const el = byId<HTMLInputElement>(id);
  return el ? el.value : '';
}

export function numData(el: HTMLElement, key: string): number | null {
  const v = el.dataset[key];
  if (v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
